import { Component, OnInit, Renderer2, ElementRef, Input } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { IdealsOneApiService } from '../services/ideals-one-api.service';
import { from } from 'rxjs';
import { asElementData, asTextData } from '@angular/core/src/view';
import { emailValidator, phoneValidator, NoMoreSpace, UsernameValidator } from '../shared/custom.validator';
// import { phoneValidator } from '../shared/confirm-phone.validator';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { timeout } from 'q';
import { Title } from '@angular/platform-browser';
import { configMsg } from '../shared/constant-messages';
import { TestingCompilerFactory } from '@angular/core/testing/src/test_compiler';
import { parse } from 'querystring';
import { Console } from 'console';
import * as moment from 'moment';
import { Subscription, interval } from 'rxjs';
import { countries } from '../shared/country-data-store';
import { states } from '../shared/state-data-store';
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { States } from '../shared/state.model';

let setTokenData: any;
let setNMIToken: any;
let selectFormName: any;
let qntSelectFormName: any;
declare function loadNMIScript(): any;
declare var usaepay: any;
var payToken: string;

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})

export class PaymentComponent implements OnInit {
  countriesList: any;
  statesList: any;
  cardConnectPaymentForm: FormGroup;
  quantityForm: FormGroup;
  g_ccFormValue: any;
  cardTypes: any;
  yearsList: any = [];
  quantityList: any = [];
  api_connect: any;
  payeezy_auth: any;
  getTokenData: any;
  tokenDataObj: any;
  orderStatus: any = [];
  ordersQty: any;
  completeSale: any;
  addedItemsStatus: any;
  loader: boolean;
  loaderUpdateRemove: boolean;
  showPayDiv: boolean;
  makePayBtn: boolean;
  // basesiteUrls: any;
  payErrors: any;
  updateQuantitys: any;
  removeItemFromOrderStatus: any;
  ticketDataNotAvl: boolean;
  payLoader: boolean;
  discountedPrice: boolean;
  applyOffer: any;
  pageInformations: any;
  headerData: any;
  termsConditions: string;
  isTermsConditions: boolean;
  siteInformations: any;
  breadcrumbCaptions: any;
  primary_symbol: any;
  oldGrandTotal: any;
  texHeading: any;
  tokenization_key: any;
  private subscription: Subscription;
  dateNow: any;
  expiry: any;
  milliSecondsInASecond: number = 1000;
  hoursInADay: number = 24;
  minutesInAnHour: number = 60;
  SecondsInAMinute: number = 60;
  timeDifference: any;
  secondsToDday: any = 0;
  minutesToDday: any = 0;
  hoursToDday: any = 0;
  daysToDday: any;
  counter: any = false;
  amountValue: any = 0;
  requires_reservation: any;
  internal_menu: any;
  initalClick: boolean;
  invalidFields: boolean;
  wait_time_message: any = '';
  warningMessage: string = '';
  operatingSchedule: any;
  selectedNewCard: boolean = false;
  storedCards: any = [];
  disablePayButton: string = 'Select Payment Method';
  selectedObject: any;
  cashless_name: string = '';

  closeResult: any = '';
  loginModalReference: NgbModalRef;
  isVerificationScreen: boolean = false;
  customerData: any;
  emailAddress: any;
  phoneNumber: any;
  verificationCode: any;
  isEmailError: any;
  isPhoneError: any;
  isEmail: boolean = false;
  isPhone: boolean = false;
  customerInformation: any;
  isCodeError: any = '';
  customerName: string = 'Login';
  customerProfile: any = 'assets/img/user_profile.png';
  isDefault: boolean = true;
  showDefaultCountry: any;
  showDefaultState: any;

  allowTips: boolean;
  globalFooter: any = "";
  footerElement: any;
  customerInfo: any;
  customerFormData: any;
  service_fee: any;
  service_fee_name: any;
  service_fee_amount: any = 0;
  discountName: any = "";
  showDiscountSection: boolean = false;

  constructor(private cookieService: CookieService,
    private idealsOneApiService: IdealsOneApiService, private formBuilder: FormBuilder, private router: Router,
    private renderer: Renderer2, private location: Location, private elementRef: ElementRef, private titleService: Title, private modalService: NgbModal, private sanitizer: DomSanitizer) {

    this.cardTypes = [
      'Visa',
      'Master Card',
      'American Express',
      'Discover'
    ];

    this.requires_reservation = false;
    this.loader = true;
    this.loaderUpdateRemove = false;
    this.ticketDataNotAvl = false;
    this.showPayDiv = false;
    this.makePayBtn = false;
    this.payLoader = false;
    this.discountedPrice = false;
    this.isTermsConditions = false;
    let clearTokenData: any;
    this.internal_menu = false;
    this.invalidFields = true;

    this.initalClick = true;
    this.getYearList();
    this.getQuantityList();
    this.getPageInformation();
    this.api_connect = idealsOneApiService.api_connect;
    this.payeezy_auth = idealsOneApiService.payeezy_auth;
    this.tokenization_key = idealsOneApiService.tokenization_key;
    console.log('[payment component] api_connect: ' + JSON.stringify(this.api_connect));
    console.log('[payment component] payeezy_auth: ' + JSON.stringify(this.payeezy_auth));
    console.log('[payment component] tokenization_key: ' + this.tokenization_key);
    // this.api_connect = (this.cookieService.get('api_connect'));

    this.statesList = states;
    this.showDefaultState = 'Choose country first';

    if (sessionStorage['siteInformations']) {
      this.siteInformations = JSON.parse(sessionStorage['siteInformations']);
      console.log('payment component] siteInformations: ' + this.siteInformations);
      this.countriesList = ((this.siteInformations.data.countries === '') || (this.siteInformations.data.countries === undefined))
        || (this.siteInformations.data.countries.length === 0) ? countries : this.siteInformations.data.countries;
    } else {
      this.countriesList = countries;
    }

    if (this.countriesList.length) {
      this.showDefaultCountry = this.countriesList[0].code;
      sessionStorage['country'] = this.countriesList[0].code;
    }

    if ((this.siteInformations !== undefined) && (this.siteInformations.data.currency.payment.payment_processor === 'cardconnect')) {
      window.addEventListener('message', function (event) {

        // if (sessionStorage['siteInformations']) {
        //   var siteInformations = JSON.parse(sessionStorage['siteInformations']);
        // }
        // // If working on card connect payment gateway
        // if( (siteInformations == undefined) || (siteInformations.data.currency.payment.payment_processor == "cardconnect"))

        if (true) {
          if (event.data.action === undefined) {
            console.log('received windows message: ' + event.data);
            if (event.data) {
              try {
                JSON.parse(event.data);
                const objEventData = JSON.parse(event.data);
                if (objEventData.message) {
                  setTokenData(event.data);
                } else {
                  console.log('No token---:' + objEventData.message);
                  document.getElementById('cardNumberValidationError').innerHTML = configMsg.invalidCard;

                  clearTokenData();
                }
              } catch (e) {
                return false;
              }
            }
          }
        }
      }, false);
    }
    if ((this.siteInformations !== undefined) && (this.siteInformations.data.currency.payment.payment_processor === 'nmi')) {
      this.statesList = states.filter(this.filterStates); // filter states dropdown according to default country
      if (this.statesList.length) { // select first state as default so sessionStorage state is never empty
        sessionStorage['state'] = null;
        this.showDefaultState = null;
      }
      this.invalidFields = !(sessionStorage['state'] && sessionStorage['country']);

      // load NMI script dynamically
      console.log('Dynamically altering NMI script.');
      const script = document.getElementById('nmi_script') as HTMLScriptElement;
      script.setAttribute('data-tokenization-key', this.tokenization_key);
      if (this.siteInformations.data.currency.payment.nmi_currency != null) {
        script.setAttribute('currency', this.siteInformations.data.currency.payment.nmi_currency);
        console.log('Currency set to ' + this.siteInformations.data.currency.payment.nmi_currency);
      } else {
        console.log('ERROR!!!! nmi_currency field is missing from siteInformation.');
      }
      script.src = 'https://secure.networkmerchants.com/token/Collect.js';
      console.log('New NMI script URL: ' + script.src);
    }

    setTokenData = (tokenData: any) => {
      console.log('tokenData---------' + tokenData);
      this.tokenDataObj = JSON.parse(tokenData);
      if (this.tokenDataObj.message) {
        document.getElementById('cardNumberValidationError').innerHTML = '';
        this.getTokenData = this.tokenDataObj.message;
        (document.getElementById('ccToken') as HTMLInputElement).value = this.tokenDataObj.message;
        this.cardConnectPaymentForm.patchValue({ ccToken: this.tokenDataObj.message });
        const cardToken = this.cardConnectPaymentForm.value.ccToken;
        const cardTokenLength = cardToken.length;
        const first2 = cardToken.substr(1, 2);
        const first6 = first2 + '****';
        const last4 = cardToken.substr((cardTokenLength - 4), 4);
        this.cardConnectPaymentForm.patchValue({ first_6: first6 });
        this.cardConnectPaymentForm.patchValue({ last_4: last4 });
      }

    };

    clearTokenData = () => {
      this.cardConnectPaymentForm.patchValue({ ccToken: '' });
      this.cardConnectPaymentForm.patchValue({ first_6: '' });
      this.cardConnectPaymentForm.patchValue({ last_4: '' });
    };

    // setInterval(() => { this.removeExpirationProduct() }, 1000);
  }

  get firstName() {
    return this.cardConnectPaymentForm.get('fName');
  }

  get email() {
    return this.cardConnectPaymentForm.get('email');
  }

  get confirmEmail() {
    return this.cardConnectPaymentForm.get('confirmEmail');
  }

  get phone() {
    return this.cardConnectPaymentForm.get('phone');
  }

  get confirmPhone() {
    return this.cardConnectPaymentForm.get('confirmPhone');
  }

  get nameOnCreditCard() {
    return this.cardConnectPaymentForm.get('nameOnCreditCard');
  }

  get cardType() {
    return this.cardConnectPaymentForm.get('cardType');
  }

  get expMonth() {
    return this.cardConnectPaymentForm.get('expMonth');
  }

  get expYear() {
    return this.cardConnectPaymentForm.get('expYear');
  }

  get ccv() {
    return this.cardConnectPaymentForm.get('ccv');
  }

  get ccexp() {
    return this.cardConnectPaymentForm.get('ccexp');
  }

  get cvv() {
    return this.cardConnectPaymentForm.get('cvv');
  }

  get streetAddressCard() {
    return this.cardConnectPaymentForm.get('streetAddressCard');
  }

  get cityCard() {
    return this.cardConnectPaymentForm.get('cityCard');
  }

  get stateCard() {
    return this.cardConnectPaymentForm.get('stateCard');
  }

  get termsAndCondi() {
    return this.cardConnectPaymentForm.get('termsAndCondi');
  }
  get streetAddress() {
    return this.cardConnectPaymentForm.get('streetAddress');
  }
  get city() {
    return this.cardConnectPaymentForm.get('city');
  }
  get state() {
    return this.cardConnectPaymentForm.get('state');
  }
  get zipCode() {
    return this.cardConnectPaymentForm.get('zipCode');
  }

  get ccToken() {
    return this.cardConnectPaymentForm.get('ccToken');
  }

  ngOnInit() {

    // Access footer ID
    this.footerElement = document.getElementById('paymentFooterID') as HTMLElement;

    const pageInfoReqTimer = setTimeout(this.checkOrderStatus, 2000);
    // this.subscription = interval(1000).subscribe(x => { this.getTimeDifference(); });

    if (sessionStorage['pageinformationData']) {
      this.pageInformations = JSON.parse(sessionStorage.getItem('pageinformationData'));
      console.log("this.pageInformations", this.pageInformations);

      if (sessionStorage['breadcrumbInfo']) {
        this.breadcrumbCaptions = JSON.parse(sessionStorage.getItem('breadcrumbInfo'));
      }

      if (this.pageInformations.data) {

        if (this.pageInformations.data.header) {
          this.headerData = this.pageInformations.data.header;
        }

        if (this.pageInformations.data.body) {
          document.body.style.backgroundColor = this.pageInformations.data.body.background_color;
        }
      }

      // if (this.pageInformations.data.captions) {
      //   this.setDocTitle(this.pageInformations.data.captions.cart);
      // }

      if (this.pageInformations.data.title) {
        this.setDocTitle(this.pageInformations.data.title);
      }

      // this.navigationData = this.pageInformations.data.navigation.items;

      // if (!this.pageInformations.data.navigation.items) {
      //   this.renderer.addClass(document.body, 'no-nav');
      // }

      if (this.pageInformations.data.initial_page.terms_and_conditions.terms_and_conditions_display === true) {
        this.termsConditions = this.pageInformations.data.initial_page.terms_and_conditions.terms_and_conditions_message;
        this.isTermsConditions = true;
      }

    } else {
      console.log('No session data');
    }

    if (sessionStorage['siteInformations']) {
      this.siteInformations = JSON.parse(sessionStorage['siteInformations']);
      this.primary_symbol = this.siteInformations.data.currency.primary_symbol;
      this.cashless_name = this.siteInformations.data.currency.cashless_name == "" ? 'Fun Card' : this.siteInformations.data.currency.cashless_name;
      this.texHeading = this.siteInformations.data.localization.tax_heading;
      console.log('siteInformations---payment- str-:', this.siteInformations);
      const backgroundStyle = this.siteInformations.data.background_style;
      document.body.style.backgroundImage = 'url(' + backgroundStyle + ')';

      // Inject global footer scripting from site info response.
      if (this.siteInformations.data.global_footer_html != "" || this.siteInformations.data.global_footer_html != undefined) {
        this.globalFooter = this.siteInformations.data.global_footer_html;
        let removeDoctype = this.globalFooter.replace('<!DOCTYPE html>', '').replace('</html>', '').trim();
        this.footerElement.innerHTML = removeDoctype;
      }

    }

    // service_fee disclosure
    if (this.siteInformations.data.service_fee != undefined && this.siteInformations.data.service_fee.disclosure != undefined) {
      this.service_fee = this.siteInformations.data.service_fee.disclosure;
    }

    this.customerInfo = sessionStorage.customerInfo ? JSON.parse(sessionStorage.customerInfo) : null;
    this.customerFormData = sessionStorage.customerFormData ? JSON.parse(sessionStorage.customerFormData) : null;

    if (this.customerInfo != null) {
      this.customerName = this.customerInfo.name || this.customerInfo.last_name ? `${this.customerInfo.first_name} ${this.customerInfo.last_name}` : 'Login';
      this.customerProfile = this.customerInfo.image ? this.customerProfileUrl(this.customerInfo.image) : 'assets/img/user_profile.png';
    }

  }

  getTimeDifference() {

    if (this.requires_reservation) {
      const productsItems = this.addedItemsStatus ? this.addedItemsStatus : [];

      if (productsItems) {

        productsItems.forEach((value, index, object) => {

          if (value.reservations) {
            let expiration = value.reservations.length > 0 ? value.reservations[0].expiration : "";

            let isoDate = new Date(`${expiration}`).toISOString();
            let newDateTime = new Date(isoDate);

            let CSToffSet = newDateTime.getTimezoneOffset();
            let offsetValue = CSToffSet * 60 * 1000;
            var cstDateTime = new Date(newDateTime.getTime() + offsetValue);
            this.timeDifference = cstDateTime.getTime() - new Date().getTime();
            let timeDifference = this.timeDifference;

            if (timeDifference > 0) {
              this.counter = true;
              this.secondsToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond) % this.SecondsInAMinute);
              this.minutesToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour) % this.SecondsInAMinute);
              this.hoursToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute) % this.hoursInADay);
              this.daysToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute * this.hoursInADay));
              value.expirymin = this.minutesToDday;
              value.expirysec = this.secondsToDday;

              if (this.minutesToDday == 0 && this.secondsToDday == 0) {

                object.splice(index, 1);
                this.addedItemsStatus = productsItems;

                if (this.addedItemsStatus.length < 1) {
                  this.checkOrderStatus();
                  this.ticketDataNotAvl = true;
                }
              }
            }
            else {
              this.counter = false;
            }
          }else if(value.items != undefined){  //check time difference for items of items
            value.items.forEach((item, index, object)=>{
              if (item.reservations) {
                let expiration = item.reservations.length > 0 ? item.reservations[0].expiration : "";
    
                let isoDate = new Date(`${expiration}`).toISOString();
                let newDateTime = new Date(isoDate);
    
                let CSToffSet = newDateTime.getTimezoneOffset();
                let offsetValue = CSToffSet * 60 * 1000;
                var cstDateTime = new Date(newDateTime.getTime() + offsetValue);
                this.timeDifference = cstDateTime.getTime() - new Date().getTime();
                let timeDifference = this.timeDifference;
    
                if (timeDifference > 0) {
                  this.counter = true;
                  this.secondsToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond) % this.SecondsInAMinute);
                  this.minutesToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour) % this.SecondsInAMinute);
                  this.hoursToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute) % this.hoursInADay);
                  this.daysToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute * this.hoursInADay));
                  item.expirymin = this.minutesToDday;
                  item.expirysec = this.secondsToDday;
    
                  if (this.minutesToDday == 0 && this.secondsToDday == 0) {
    
                    object.splice(index, 1);
                    this.addedItemsStatus = productsItems;
    
                    if (this.addedItemsStatus.length < 1) {
                      this.checkOrderStatus();
                      this.ticketDataNotAvl = true;
                    }
                  }
                }
                else {
                  this.counter = false;
                }
              }
              else {
                this.addedItemsStatus = productsItems;
              }
            })
          }
          else {
            this.addedItemsStatus = productsItems;
          }
          
        })
      }
    }

  }

  setDocTitle(title: string) {
    this.titleService.setTitle(title);
  }

  loadPaymentFields() {

    this.showPayDiv = true;
    this.makePayBtn = false;
    if (this.customerName != 'Login') this.cardsInformations();
    else this.selectedNewCard = true;


    // this.renderer.addClass(document.getElementById('breadcrumbSpan'), 'ckick-none');
    // this.renderer.addClass(document.getElementById('breadcrumbPayBtn'), 'not-active');
    // this.renderer.addClass(document.getElementById('breadcrumbLi'), 'active');
    if (this.siteInformations.data.currency.payment.payment_processor == "cardconnect") {
      this.cardConnectPaymentForm = this.formBuilder.group({
        fName: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        lName: [''],
        email: ['', [Validators.required, Validators.pattern('[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$')]],
        emailOptIn: [false],
        confirmEmail: ['', Validators.required],
        phone: ['', [Validators.required, Validators.pattern('[0-9]{10}'), Validators.maxLength(10)]],
        phoneOptIn: [false],
        confirmPhone: ['', Validators.required],
        streetAddress: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        city: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        state: ['', [Validators.required, UsernameValidator.noWhitespaceValidator, Validators.minLength(2)]],
        zipCode: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        sameAsPurchaser: [''],
        nameOnCreditCard: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        cardType: ['', Validators.required],
        ccToken: [''],
        first_6: [''],
        last_4: [''],
        streetAddressCard: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        cityCard: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        stateCard: ['', [Validators.required, UsernameValidator.noWhitespaceValidator, Validators.minLength(2)]],
        countryCard: [''],
        termsAndCondi: [false],
        ccexp: ['', Validators.required],
        cvv: [''],
        ccv: [''],
        expMonth: ['', Validators.required],
        expYear: ['', Validators.required],
        // ccnumber: ['', Validators.required]

      }, { validators: [emailValidator, phoneValidator] });
    }
    if (this.siteInformations.data.currency.payment.payment_processor == "nmi") {
      this.cardConnectPaymentForm = this.formBuilder.group({
        fName: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        lName: [''],
        email: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$')]],
        emailOptIn: [false],
        confirmEmail: ['', Validators.required],
        phone: ['', [Validators.required, Validators.pattern('[0-9]{10}'), Validators.maxLength(10)]],
        phoneOptIn: [false],
        confirmPhone: ['', Validators.required],
        streetAddress: ['', [Validators.required]],
        city: ['', [Validators.required]],
        state: ['', [Validators.required, Validators.minLength(2)]],
        zipCode: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        sameAsPurchaser: [''],
        nameOnCreditCard: ['', [Validators.required]],
        cardType: ['', Validators.required],
        ccToken: [''],
        first_6: [''],
        last_4: [''],
        streetAddressCard: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        cityCard: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        stateCard: [''],
        countryCard: [''],
        termsAndCondi: [false],
        ccexp: [''],
        cvv: [''],
        ccv: [''],
        expMonth: [''],
        expYear: ['']
        //ccnumber: ['0000 0000 0000 0000', Validators.required]

      }, { validators: [emailValidator, phoneValidator] });
    }
    if (this.siteInformations.data.currency.payment.payment_processor == "epay") {
      this.cardConnectPaymentForm = this.formBuilder.group({
        fName: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        lName: [''],
        email: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$')]],
        emailOptIn: [false],
        confirmEmail: ['', Validators.required],
        phone: ['', [Validators.required, Validators.pattern('[0-9]{10}'), Validators.maxLength(10)]],
        phoneOptIn: [false],
        confirmPhone: ['', Validators.required],
        streetAddress: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        city: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        state: ['', [Validators.required, UsernameValidator.noWhitespaceValidator, Validators.minLength(2)]],
        zipCode: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        sameAsPurchaser: [''],
        nameOnCreditCard: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        cardType: ['', Validators.required],
        ccToken: [''],
        first_6: [''],
        last_4: [''],
        streetAddressCard: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        cityCard: ['', [Validators.required, UsernameValidator.noWhitespaceValidator]],
        stateCard: ['', [Validators.required, UsernameValidator.noWhitespaceValidator, Validators.minLength(2)]],
        countryCard: ['', Validators.required],
        termsAndCondi: [false],
        ccexp: [''],
        cvv: [''],
        ccv: [''],
        expMonth: [''],
        expYear: [''],
        // ccnumber: ['', Validators.required]

      }, { validators: [emailValidator, phoneValidator] });
    }

    const loadIframe = () => {
      const iframefield = document.getElementById('tokenframe') as HTMLImageElement;
      // tslint:disable-next-line:max-line-length
      iframefield.src = 'https://ideal.cardconnect.com' + (this.api_connect.env === 'development' ? ':6443' : '') + '/itoke/ajax-tokenizer.html?useexpiry=false&usecvv=false&css=.error%7Bcolor%3Ared%3Bborder-color%3Ared%7Dbody%7Bmargin%3A0%7Dinput%7Bborder%3A0%20solid%20%23ccc%7Dinput%3Afocus%7Boutline%3Anone%7D%23ccnumfield%7Bwidth%3A280px%3Bheight%3A23px%3Bpadding-left%3A10px%3Bmargin-top%3A1px%3Bpadding-top%3A1px%3Bpadding-bottom%3A1px%3Bfont-size%3A1rem%3Bfont-weight%3A400%3Bline-height%3A1.5%7Dselect%7Bheight%3A28px%3Bmargin-top%3A10px%3Bpadding-left%3A10px%3Bmargin-right%3A10px%7D%23cccvvfield%7Bwidth%3Aauto%3Bheight%3A28px%3Bmargin-top%3A10px%3Bpadding-left%3A10px%7D&invalidinputevent=true';

      if (this.pageInformations.data.initial_page.terms_and_conditions.terms_and_conditions_display === true) {
        this.cardConnectPaymentForm.controls['termsAndCondi'].setErrors({ 'incorrect': true });
      }

      // if (this.pageInformations.data.captions) {
      //   this.setDocTitle(this.pageInformations.data.captions.payment);
      // }

      if (this.pageInformations.data.title) {
        this.setDocTitle(this.pageInformations.data.title);
      }
    };

    const loadEPay = () => {
      let client = new usaepay.Client(this.payeezy_auth.cc_merch_id);
      let paymentCard = client.createPaymentCardEntry();

      let renderEpayCard = function () {
        let cssStyle = `#payjs-container {display: block; width: 98%; min-width: 260px; margin: auto; background-color: #fff;} .payjs-input-icon {width: 14%; min-width: 60px; max-width: 110px; margin-left: 8%; height: auto;} #payjs-container input {height: 38px; font-size: 1rem; background-color: #fff; border-style: solid; border-color: #ccc; border-width: 0 0 1px 0; border-bottom: 1px solid #08507d;} #payjs-cnum {width: 66%; float: right;} #payjs-exp {width: 31%; float: left; margin-top: 18px; margin-left: -.5%; margin-right: 3.5%; padding-left: 10px;} #payjs-cvv {width: 32%; margin-top: 18px; padding-left: 10px;}`;
        let style = {}
        paymentCard.generateHTML(style);
        paymentCard.payCardStyles = cssStyle;
        paymentCard.addHTML('paymentCardContainer');

        paymentCard.addEventListener('error', errorMessage => {
          let errorContainer = document.getElementById('paymentCardErrorContainer');
          errorContainer.textContent = errorMessage;
        });

        let form = document.getElementById('cardConnectPayForm');

        form.addEventListener('submit', event => {
          event.preventDefault();
          client.getPaymentKey(paymentCard).then(result => {
            if (result.error) {
              let errorContainer = document.getElementById('paymentCardErrorContainer');
              errorContainer.textContent = result.error.message;
            }
            else {
              tokenHandler(result);
            }
          }).catch(err => {

          });
        })

        function tokenHandler(token) {
          payToken = token;
          //setTimeout(function () {
          //console.log('FORM TOKEN: ' + (document.getElementById('ccToken') as HTMLInputElement).value);
          //}, 1000);
        }
      }
      setTimeout(function () { renderEpayCard(); }, 500);
    }
    /*
        if (this.siteInformations.data.currency.payment.payment_processor == "cardconnect") {
          setTimeout(loadIframe, 1000);
        } else {
          setTimeout(loadNMIScript, 1000);
        }
    */
    if (this.siteInformations.data.currency.payment.payment_processor == "cardconnect") {
      setTimeout(loadIframe, 1000);
    }
    if (this.siteInformations.data.currency.payment.payment_processor == "nmi" && this.selectedNewCard) {
      setTimeout(loadNMIScript, 1000);
    }
    if (this.siteInformations.data.currency.payment.payment_processor == "epay") {
      setTimeout(loadEPay, 1000);
    }
    const scrollToPay = () => {
      const payElement = document.getElementById('ccPaymentForm');
      payElement.scrollIntoView();
    };

    setTimeout(scrollToPay, 500);


    // PhoneValidator

    // this.cardConnectPaymentForm.get('emailOptIn').valueChanges
    //   .subscribe(checkedValue => {
    //     const email = this.cardConnectPaymentForm.get('email');
    //     const confirmEmail = this.cardConnectPaymentForm.get('confirmEmail');

    //     if (checkedValue) {
    //       email.setValidators([Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$')]);
    //       confirmEmail.setValidators(Validators.required);
    //     } else {
    //       email.clearValidators();
    //       confirmEmail.clearValidators();
    //     }

    //     email.updateValueAndValidity();
    //     confirmEmail.updateValueAndValidity();
    //   });


    // this.cardConnectPaymentForm.get('phoneOptIn').valueChanges
    //   .subscribe(checkedValuePhone => {
    //     const phone = this.cardConnectPaymentForm.get('phone');
    //     const confirmPhone = this.cardConnectPaymentForm.get('confirmPhone');

    //     if (checkedValuePhone) {
    //       phone.setValidators([Validators.required, Validators.pattern('[0-9]{10}'), Validators.maxLength(10)]);
    //       confirmPhone.setValidators(Validators.required);
    //     } else {
    //       phone.clearValidators();
    //       confirmPhone.clearValidators();
    //     }

    //     phone.updateValueAndValidity();
    //     confirmPhone.updateValueAndValidity();
    //   });

    this.cardConnectPaymentForm.get('termsAndCondi').valueChanges
      .subscribe(checkedValue => {
        const tAndC = this.cardConnectPaymentForm.get('termsAndCondi');
        console.log(tAndC);

        if (!checkedValue) {
          if (checkedValue === false) {
            this.cardConnectPaymentForm.controls['termsAndCondi'].setErrors({ 'incorrect': true });
          }
        }

      });

    this.cardConnectPaymentForm.get('sameAsPurchaser').valueChanges
      .subscribe(checkedValue => {
        const sameAs = this.cardConnectPaymentForm.get('sameAsPurchaser');
        if (!checkedValue) {
          this.cardConnectPaymentForm.patchValue({ streetAddressCard: '' });
          this.cardConnectPaymentForm.patchValue({ cityCard: '' });
          //this.cardConnectPaymentForm.patchValue({ stateCard: '' });

        } else {
          const atreetAddr = this.cardConnectPaymentForm.value.streetAddress;
          const city = this.cardConnectPaymentForm.value.city;
          const stateName = this.cardConnectPaymentForm.value.state.toUpperCase();
          if (stateName) {
            var foundState = this.statesList.find(state => state.name === stateName);
            if ((!foundState) && sessionStorage['country']) {

              const countryCode = sessionStorage['country'];
              const stateCode = countryCode.toUpperCase() + '-' + stateName;
              foundState = this.statesList.find(state => state.code === stateCode); //user may have entered state code instead of its name
            }
            if (foundState) {
              const countryCode = foundState.country;
              this.cardConnectPaymentForm.patchValue({ stateCard: foundState.code });
              this.cardConnectPaymentForm.patchValue({ countryCard: countryCode });
              sessionStorage['country'] = countryCode;
              sessionStorage['state'] = this.cleanupState(foundState.code);

            }
          }
          this.cardConnectPaymentForm.patchValue({ streetAddressCard: atreetAddr });
          this.cardConnectPaymentForm.patchValue({ cityCard: city });
          this.invalidFields = !(sessionStorage['state'] && sessionStorage['country']);
        }
      });

    // prefill customer informations
    if (this.customerFormData != null) {

      let prefillCustomer = {
        fName: this.customerFormData.fname,
        lName: this.customerFormData.lname,
        email: this.customerFormData.email,
        confirmEmail: this.customerFormData.email,
        phone: this.customerFormData.phone,
        confirmPhone: this.customerFormData.phone,
      }

      this.cardConnectPaymentForm.patchValue(prefillCustomer);
    }
    else {
      let prefillCustomer = {
        fName: this.customerInfo.first_name,
        lName: this.customerInfo.last_name,
        email: this.customerInfo.email_address,
        confirmEmail: this.customerInfo.email_address,
        phone: this.customerInfo.phone_mobile,
        confirmPhone: this.customerInfo.phone_mobile,
        streetAddress: this.customerInfo.address,
        city: this.customerInfo.city,
        state: this.customerInfo.state,
        zipCode: this.customerInfo.postal_code
      }
      this.cardConnectPaymentForm.patchValue(prefillCustomer);
    }
  }

  loadImgFromSess = () => {

    if (this.pageInformations.data.body.items) {

      const ordersItems = this.orderStatus.data.items;
      const itemsLength = this.pageInformations.data.body.items.length;
      let cartimagecache = sessionStorage.cartimagecache ? JSON.parse(sessionStorage.cartimagecache) : [];
      const cartItems = cartimagecache;


      for (let i in this.addedItemsStatus) {
        for (let j in cartItems) {
          if (this.addedItemsStatus[i].item_number == cartItems[j].item_number) {
            if(cartItems[j].image == undefined)
            { 
            this.addedItemsStatus[i]['image'] = "assets/img/default-tickets.png";
            this.addedItemsStatus[i]['descriptions'] = cartItems[j].description
            this.addedItemsStatus[i]['captions'] = cartItems[j].caption
           }else{
            this.addedItemsStatus[i]['image'] = cartItems[j].image
            this.addedItemsStatus[i]['descriptions'] = cartItems[j].description
            this.addedItemsStatus[i]['captions'] = cartItems[j].caption
           }
          }
          else if (this.addedItemsStatus[i]['image'] == undefined) {
            this.addedItemsStatus[i]['image'] = "assets/img/default-tickets.png";
          }

        }
        document.querySelectorAll('.cartImg')[i].setAttribute('src', this.addedItemsStatus[i].image);
      }

    }
  }

  checkOrderStatus = () => {
    const orderStatusObservable = this.idealsOneApiService.orderStatusReq();
    orderStatusObservable.subscribe((orderStatusData: any) => {


      this.orderStatus = orderStatusData;
      this.subscription = interval(1000).subscribe(x => { this.getTimeDifference(); });

      if (!this.orderStatus.data.items) {

        sessionStorage.removeItem('cartimagecache');
        this.subscription.unsubscribe()
      }
      var ordersList = this.orderStatus.data.items ? this.orderStatus.data.items : this.orderStatus.data;
      this.wait_time_message = this.orderStatus.data.wait_time_message ? this.orderStatus.data.wait_time_message : '';
      // this.orderStatus.data.fees = 0;

      if (this.orderStatus.data.service_fee != undefined && (this.orderStatus.data.service_fee.name != undefined || this.orderStatus.data.service_fee.amount != undefined)) {
        this.service_fee_name = this.orderStatus.data.service_fee.name;
        this.service_fee_amount = this.orderStatus.data.service_fee.amount;
      }
     
      // Display discount according to the typed_discount
      if (this.orderStatus.data.typed_discount != undefined && (this.orderStatus.data.typed_discount.description != undefined && this.orderStatus.data.typed_discount.description != "")) {

        if (this.orderStatus.data.discounts > 0) {
          this.showDiscountSection = true;
          this.discountName = this.orderStatus.data.typed_discount.description;

        } else {
          this.showDiscountSection = true;
          this.discountName = this.orderStatus.data.typed_discount.description;
        }
      } else if (this.orderStatus.data.typed_discount != undefined && this.orderStatus.data.typed_discount.description == "") {
        if (this.orderStatus.data.discounts > 0) {
          this.showDiscountSection = true;
          this.discountName = "DISCOUNTS";
        } else {
          this.showDiscountSection = false;
        }
      }
      else {
        if (this.orderStatus.data.discounts > 0) {
          this.showDiscountSection = true;
          this.discountName = "DISCOUNTS";
        }else {
          this.showDiscountSection = false;
        }
      }

      if (this.orderStatus.data.service_fee != undefined) {
        this.service_fee_name = this.orderStatus.data.service_fee.name;
        this.service_fee_amount = this.orderStatus.data.service_fee.amount;
      }



      // for (let i = 0; i < ordersList.length; i++) {

      //   let itemsMod = ordersList[i].modifiers;
      //   for (let j = 0; j < itemsMod.length; j++) {
      //     if (itemsMod[j].is_fee == true) {
      //       this.orderStatus.data.fees = this.orderStatus.data.fees + itemsMod[j].price;
      //     }
      //   }
      // }

      // var itemsQty = 0;
      // this.orderStatus.data.items.forEach(function(value){
      //   itemsQty = itemsQty + parseInt(value.quantity);
      // });
      // this.ordersQty = itemsQty;
      // console.log("ordersQty@426", this.ordersQty);
      if (this.orderStatus === undefined) {
        setTimeout(this.checkOrderStatus, 2000);
      } else {
        if (this.orderStatus.data.items) {
          this.oldGrandTotal = this.orderStatus.data.order_total;
          this.addedItemsStatus = this.orderStatus.data.items;
          const itemLength = this.orderStatus.data.items.length;
          const quantitySelectFormData = [];
          sessionStorage['addedItemsTocart'] = JSON.stringify(orderStatusData);
          // this.renderer.removeClass(document.getElementById('breadcrumbSpan'), 'ckick-none');
          setTimeout(this.loadImgFromSess, 500);

          for (let index = 0; index < itemLength; index++) {
            if (this.orderStatus.data.items[index].discounted_price) {
              this.discountedPrice = true;
            }
            qntSelectFormName = this.orderStatus.data.items[index].id;
            quantitySelectFormData.push({ [qntSelectFormName]: [''] });
          }

          const quantitySelectFormDataObj = quantitySelectFormData;
          const newQuantitySelectFormDataObj = Object.assign({}, ...quantitySelectFormDataObj);
          this.quantityForm = this.formBuilder.group(
            newQuantitySelectFormDataObj
          );

          for (let item = 0; item < itemLength; item++) {
            selectFormName = this.orderStatus.data.items[item].id;
            this.quantityForm.patchValue({ [selectFormName]: this.orderStatus.data.items[item].quantity });
          }

          if (this.showPayDiv !== true && sessionStorage['breadcrumbInfo']) {
            this.makePayBtn = true;
            // this.renderer.removeClass(document.getElementById('breadcrumbPayBtn'), 'not-active');
            // this.renderer.addClass(document.getElementById('breadcrumbSpan'), 'pointer');
          }

          this.loader = false;

        } else {
          // this.renderer.addClass(document.getElementById('breadcrumbPayBtn'), 'not-active');
          // this.renderer.addClass(document.getElementById('breadcrumbSpan'), 'ckick-none');
          let noItems = [];
          this.addedItemsStatus = noItems.length;
          this.makePayBtn = false;
          this.loader = false;
          this.ticketDataNotAvl = true;
          this.showPayDiv = false;
        }
      }

    });
  }

  // removeExpirationProduct() {
  //   const products = this.addedItemsStatus ? this.addedItemsStatus : [];
  //   const uniqueProducts = [];

  //   if (products) {

  //     products.forEach((value) => {

  //       if (value.reservations) {
  //         let currDate = new Date().toISOString();
  //         let currdatetime = moment.utc(currDate).format('YYYY-MM-DD HH:m:s');
  //         let expiration = value.reservations.length > 0 ? moment.utc(value.reservations[0].expiration).format('YYYY-MM-DD HH:m:s') : "";

  //         if (currdatetime !== expiration) {
  //           uniqueProducts.push(value);
  //           this.addedItemsStatus = uniqueProducts;
  //         }
  //       } else {
  //         uniqueProducts.push(value);
  //         this.addedItemsStatus = uniqueProducts;
  //       }
  //     })
  //   }
  // }

  removeItemFromOrder(addedItemId: any) {
    this.loaderUpdateRemove = true;
    const removeItemFromOrderObservable = this.idealsOneApiService.removeItemFromOrderReq(addedItemId);
    removeItemFromOrderObservable.subscribe((removeItemFromOrderData: any) => {
      this.removeItemFromOrderStatus = removeItemFromOrderData;

      if (this.removeItemFromOrderStatus.data.success === true) {
        this.checkOrderStatus();

        if (this.orderStatus.data) {
          this.loaderUpdateRemove = false;
        }

        this.loader = false;
      } else {
        this.checkOrderStatus();
        document.getElementById('openQntNotUpdateErrorModel').click();
      }
    });
  }

  updateQuantity(quantity: number, itemId: any) {
    this.loaderUpdateRemove = true;
    const updateQuantityObservable = this.idealsOneApiService.updateQuantityReq(quantity, itemId);
    updateQuantityObservable.subscribe((updateQuantityData: any) => {
      this.updateQuantitys = updateQuantityData;

      if (this.updateQuantitys.data.success === true) {
        this.loaderUpdateRemove = false;
        this.checkOrderStatus();
      } else {
        this.checkOrderStatus();
        document.getElementById('openQntNotUpdateErrorModel').click();
      }
    });
  }

  onCountryChange(countryCode: any) {
    sessionStorage['country'] = countryCode;
  }


  onNMICountryChange(countryCode: any) {
    sessionStorage['country'] = countryCode;
    this.statesList = states.filter(this.filterStates);
    this.invalidFields = !(sessionStorage['state'] && sessionStorage['country']);
  }

  filterStates(state: States) {
    return state.country === sessionStorage['country'];
  }

  onStateChange(stateCode: any) {
    sessionStorage['state'] = this.cleanupState(stateCode);
    if (sessionStorage['state'] === '') sessionStorage['state'] = null;
    this.invalidFields = !(sessionStorage['state'] && sessionStorage['country']);
  }

  cleanupState(state) {
    const i = state.indexOf('-');
    if (i > -1) {
      return state.substr(i + 1);
    }
    return state;
  }

  ispayNMIButtonDisabled(): boolean {
    //console.log('[ispayNMIButtonDisabled] NMIFieldsReady: ', + (sessionStorage['NMIFieldsReady'] === 'true'));
    //console.log('[ispayNMIButtonDisabled] state: ', + (sessionStorage['state'] !== null));
    //console.log('[ispayNMIButtonDisabled] country: ', + (sessionStorage['country'] !== null));
    //console.log('[ispayNMIButtonDisabled] cardConnectPaymentForm.valid: ', + (this.cardConnectPaymentForm.valid) );
    // console.log('[ispayNMIButtonDisabled] initalClick: ', + this.initalClick);
    var retVal: boolean = (sessionStorage['NMIFieldsReady'] === 'true');
    if (retVal) retVal = (sessionStorage['state'] !== 'null');
    if (retVal) retVal = (sessionStorage['country'] !== 'null');
    if (retVal) retVal = (this.cardConnectPaymentForm.valid === true);
    if (retVal) retVal = this.initalClick;

    return (!retVal);
  }

  loadStorageSpace(ccFormValue: any) {  // this is only called when NMI is the processor and the nmi button has been clicked
    this.initalClick = false;
    sessionStorage['city'] = ccFormValue.cityCard;
    sessionStorage['email'] = ccFormValue.email;
    sessionStorage['address1'] = ccFormValue.streetAddressCard;
    sessionStorage['firstName'] = ccFormValue.fName;
    sessionStorage['lastName'] = ccFormValue.lName;
    sessionStorage['postalCode'] = ccFormValue.zipCode;
    sessionStorage['phone'] = ccFormValue.phone;
    //sessionStorage['state'] = this.cleanupState(ccFormValue.stateCard);
    sessionStorage['amount'] = this.orderStatus.data.order_total;    //Math.round(this.orderStatus.data.order_total*100);
    sessionStorage['challengeIndicator'] = '04';  // hardwired to the value recommended by NMI
  }

  getTkn() {
    setTimeout(() => {
      if (payToken) {
        // this.cardConnectPaymentForm.patchValue({ ccToken: payToken });
        this.cardConnectPaymentForm.patchValue({ first_6: payToken.substring(0, 6) });
        this.cardConnectPaymentForm.patchValue({ last_4: payToken.substring(payToken.length - 4) });
        setTimeout(() => {
          this.makePaymentCc(this.cardConnectPaymentForm.value);
        }, 500);
      } else {
        this.getTkn();
      }
    }, 25);
  }

  makePaymentCc(ccFormValue: any) {
    // console.log('FORM VALUE :', ccFormValue);
    this.g_ccFormValue = ccFormValue;
    this.payLoader = true;

    const pageId = JSON.parse(sessionStorage.getItem('pageinformationData')).data.page_id;
    var payment_token: any = sessionStorage['payment_token'];
    if ((this.siteInformations.data.currency.payment.payment_processor == 'cardconnect') || (this.siteInformations.data.currency.payment.payment_processor == 'nmi')) {
      if (payment_token == null) payment_token = ccFormValue.ccToken;
    }
    if (this.siteInformations.data.currency.payment.payment_processor == 'epay') {
      if (payment_token == null) payment_token = payToken;
    }

    var tipValue = parseFloat(this.amountValue);

    let routing_override = sessionStorage.routing_override ? JSON.parse(sessionStorage.routing_override) : '';

    const completeSaleObservable = this.idealsOneApiService.completeSaleReq(ccFormValue, pageId, payment_token, tipValue, routing_override);
    completeSaleObservable.subscribe((completeSaleData: any) => {
      this.completeSale = completeSaleData;
      // console.log("Check Intial clicking");

      if (this.completeSale.data != null) {
        if (this.completeSale.data.success === true) {

          this.initalClick = true;
          console.log("COMPLETE_SALE SUCCESS. view_ticket_url=" + this.completeSale.data.view_ticket_url);
          this.payLoader = false;
          sessionStorage.removeItem('customerFormData')
          sessionStorage['completeSale'] = JSON.stringify(this.completeSale);
          sessionStorage['viewTicketUrl'] = this.completeSale.data.view_ticket_url;
          sessionStorage.removeItem('addedItemsTocart');
          sessionStorage.removeItem('cartimagecache');

          //For storing the cardInfo
          if (!this.selectedNewCard && this.customerName != 'Login') {
            let aliasName = ccFormValue.cardType + " " + ccFormValue.last_4;
            let brand = ccFormValue.cardType;
            let ccToken = ccFormValue.ccToken;
            let nameOnCCard = ccFormValue.nameOnCreditCard;
            let first_6 = ccFormValue.first_6;
            let last_4 = ccFormValue.last_4;
            let expMonth = ccFormValue.expMonth;
            let expYear = ccFormValue.expYear;
            let postalCode = ccFormValue.zipCode;
            let storeCardObservable = this.idealsOneApiService.storeCreditCardReq(aliasName, brand, ccToken, nameOnCCard, first_6, last_4, expMonth, expYear, postalCode);
            storeCardObservable.subscribe((storeCardData: any) => {
              // console.log("storeCardData", storeCardData)
            });
          }

          this.router.navigateByUrl('/payConfirmation');
          sessionStorage.removeItem("routing_override");
        }
        else {
          console.log("COMPLETE_SALE ERROR");
          this.payLoader = false;
          document.getElementById('openPayErrorsModal').click();
          this.payErrors = this.completeSale.data.error;
        }
      }
    });

  }

  // apply offer code
  applyOfferCodeReq(offerCode: any) {
    this.loaderUpdateRemove = true;
    const applyDiscountObservable = this.idealsOneApiService.applyDiscountReq(offerCode);
    applyDiscountObservable.subscribe((applyDiscountData: any) => {
      this.applyOffer = applyDiscountData;
      console.log('-applyOffer---str------:' + JSON.stringify(this.applyOffer));

      if (this.applyOffer.data.success === true) {
        this.loaderUpdateRemove = false;
        this.checkOrderStatus();
      }
      else {
        this.loaderUpdateRemove = false;
        this.checkOrderStatus();
      }
    });
  }

  stateChanged(amt) {
    var txtAmount = (document.getElementById("txtAmt") as HTMLInputElement).value;
    var tipAmount = 0;

    if (amt) {
      tipAmount = this.orderStatus.data.sub_total * (amt / 100);
    }
    else {
      if (txtAmount !== "") {
        tipAmount = parseFloat(txtAmount);
      }
    }
    this.orderStatus.data.order_total = this.oldGrandTotal;
    this.orderStatus.data.order_total = this.orderStatus.data.order_total + tipAmount;
    this.amountValue = tipAmount.toFixed(2);

    // update service fee according to the client mention calculation on jira ticket.
    if (this.siteInformations.data.service_fee != undefined && this.siteInformations.data.service_fee.percentage != undefined) {
      this.service_fee_amount = (this.orderStatus.data.order_total_minus_fees + this.orderStatus.data.tax + parseFloat(this.amountValue)) * this.siteInformations.data.service_fee.percentage / 100;
    }
  }

  keyStateChanged() {

    var txtAmount = this.amountValue;
    this.orderStatus.data.order_total = this.oldGrandTotal;

    if (txtAmount) {
      this.orderStatus.data.order_total = this.orderStatus.data.order_total + parseFloat(txtAmount);
    }
    if (txtAmount == "") {
      var ele = document.getElementsByClassName("tipRadio");
      for (var i = 0; i < ele.length; i++) {
        ele[i]['checked'] = false;
      }
    }
  }

  emptyRadioValue() {

    this.amountValue = "";
    this.orderStatus.data.order_total = this.oldGrandTotal;
    var ele = document.getElementsByClassName("tipRadio");
    for (var i = 0; i < ele.length; i++) {
      ele[i]['checked'] = false;
    }
  }

  goBackToShopping() {
    this.location.back();
  }

  // Year list current - +20 year
  getYearList() {
    const date = new Date();
    const ndate = date.getFullYear();

    for (let index = 0; index <= 15; index++) {
      this.yearsList.push(ndate + index);
    }
  }

  // Quantity list till 10
  getQuantityList() {
    const qnt = 1;
    for (let index = 0; index <= 9; index++) {
      this.quantityList.push(qnt + index);
    }
  }

  getPageInformation() {

    let pageInfo = sessionStorage.pageinformationData ? JSON.parse(sessionStorage.pageinformationData) : '';
    this.operatingSchedule = pageInfo.data.operating_schedule ? pageInfo.data.operating_schedule : {};
    if (Object.keys(this.operatingSchedule).length > 0) { this.checkShopStatus(); }

    if (pageInfo.data.body.items) {

      this.allowTips = pageInfo.data.allow_tips;
      this.internal_menu = pageInfo.data.internal_menu;
      this.requires_reservation = false;
      let pageInfoItems = pageInfo.data.body.items;
      for (let i = 0; i < pageInfoItems.length; i++) {
        if (pageInfoItems[i].requires_reservation == true) {
          this.requires_reservation = true;
        }
      // check requires reservation for child item start
      let pageInfoItemsofItems = [];
      if (pageInfoItems[i].items) {
        for (let j in pageInfoItems[i].items) {
          pageInfoItemsofItems.push(pageInfoItems[i].items[j])
        }
      }
      if (pageInfoItemsofItems.length) {
        this.requires_reservation = false;
        for (let i = 0; i < pageInfoItemsofItems.length; i++) {
          if (pageInfoItemsofItems[i].requires_reservation == true) {
            this.requires_reservation = true;
          }
        }
      }
      // check requires reservation for child item end
      }

      
                 
    }

  }

  // here we are showing closed message and warning message on product page.
  checkShopStatus() {

    let openTime, closeTime, waitTime, difference, curDTime, weekday, daysArray;
    daysArray = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

    curDTime = moment().utc().format();
    weekday = daysArray[moment.utc().format("e")];
    openTime = moment.utc(this.operatingSchedule[weekday].open).format();
    closeTime = moment.utc(this.operatingSchedule[weekday].close).format();
    difference = moment.utc(this.operatingSchedule[weekday].close).diff(curDTime, 'minutes');
    waitTime = Math.round(difference);

    if ((curDTime >= openTime && curDTime <= closeTime) && waitTime > this.operatingSchedule.warning_minutes) {
      this.warningMessage = '';
    }
    else if (waitTime > 0 && waitTime <= this.operatingSchedule.warning_minutes) {
      this.warningMessage = this.operatingSchedule.warning_message;
    }
    else {
      this.warningMessage = this.operatingSchedule.closed_message;
    }
  }

  selectedCardForPayment(event, index) {
    this.selectedObject = this.storedCards[index - 1]
    this.disablePayButton = event.target.value;
    if (event.target.value === 'addNewCard') {
      this.selectedNewCard = false;
      if (this.siteInformations.data.currency.payment.payment_processor == "nmi") {
        setTimeout(loadNMIScript, 1000);
      }
    } else {
      this.selectedNewCard = true;
    }

    // Recalculating service fee if service_fee_percentage property is coming in list_stored_credit_cards API response
    if (this.selectedObject != undefined && (this.selectedObject.service_fee_percentage != "" && this.selectedObject.service_fee_percentage != undefined)) {
      this.service_fee_amount = (this.orderStatus.data.order_total_minus_fees + this.orderStatus.data.tax + parseFloat(this.amountValue)) * this.selectedObject.service_fee_percentage / 100;
    }
    else if (this.selectedObject != undefined) {
      this.service_fee_amount = 0;
    }

  }

  cardsInformations() {
    // credit card information API is - list_stored_credit_cards
    let savedCardObservable = this.idealsOneApiService.savedCreditCardReq();
    savedCardObservable.subscribe(async (cardInfo: any) => {

      if (cardInfo != undefined) {

        if (cardInfo.data.cards) {
          this.storedCards = cardInfo.data.cards;

          this.storedCards.forEach((ccard) => {
            ccard.alias = `${ccard.alias} - 0${ccard.exp_month}/${ccard.exp_year}`;
          });

          this.selectedNewCard = true;
          let updatedCashlessArr: any = [];

          let cashlessInfo = this.cashlessRecords();
          if (cashlessInfo) {
            cashlessInfo.then((response: any) => {
              updatedCashlessArr = response;

              // Assign required cashless cards
              updatedCashlessArr.forEach((card: any) => {

                if (card.value > this.orderStatus.data.order_total) {
                  let object = {
                    alias: `${this.cashless_name} ${card.alias === "" ? card.vid === undefined ? card.card_id : card.vid : card.alias} - ${this.primary_symbol}${card.value}.00`,
                    customer_name: card.customer_name,
                    value: card.value,
                    card_id: card.card_id
                  }
                  this.storedCards.unshift(object)
                }
              })

            }, (error) => {
              console.log(error);
            })
          }
        }
      }
    })
  }

  cashlessRecords() {

    return new Promise((resolve, reject) => {
      let cardData = []
      let cashlessCardsObservable = this.idealsOneApiService.cashlessCardReq();
      cashlessCardsObservable.subscribe((cashlessData: any) => {

        if (cashlessData != undefined) {
          if (cashlessData.data.items) {
            cashlessData.data.items.forEach((element, index) => {

              // if (index == 0) {
              //   cashlessData.data.items[index].value = 35;
              //   cashlessData.data.items[index].alias = '';
              //   cashlessData.data.items[index].VID = 4398;
              // }

              // if (index == 1) {
              //   cashlessData.data.items[index].value = 30;
              //   cashlessData.data.items[index].alias = '';
              //   //cashlessData.data.items[index].VID = 5060;
              // }

              // pushing cards items having value greater than 0
              if (element.value > 0) {
                cardData.push(element)
              }
            })
            resolve(cardData)
          }
        }
        else {
          reject('Error occur while fetching records')
        }
      })
    })
  }

  MakePaymentSaveCard(event: any, ccFormValue: any, selectedObject: any) {
    event.stopPropagation();
    this.payLoader = true;
    var selectedCardData = selectedObject;

    let cardInfo = {
      nameOnCreditCard: selectedCardData.customer_name ? selectedCardData.customer_name : "",
      cardType: selectedCardData.brand ? selectedCardData.brand : "",
      ccToken: selectedCardData.payment_token ? selectedCardData.payment_token : "",
      first_6: selectedCardData.first_6 ? selectedCardData.first_6 : "",
      last_4: selectedCardData.last_4 ? selectedCardData.last_4 : "",
      expMonth: selectedCardData.exp_month ? selectedCardData.exp_month : 0,
      expYear: selectedCardData.exp_year ? selectedCardData.exp_year : 0,
      card_id: selectedCardData.card_id ? selectedCardData.card_id : "",
      cCardId: selectedCardData.id ? selectedCardData.id : "",
      ccexp: selectedCardData.card_id ? selectedCardData.card_id : "",
    }
    this.makePaymentCc(cardInfo);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openLoginModal(loginData) {
    this.loginModalReference = this.modalService.open(loginData);
    this.loginModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openLoginDialog(login) {
    this.openLoginModal(login)
  }

  closeLogin() {
    this.loginModalReference.close();
    this.isVerificationScreen = false;
    this.isEmail = false;
    this.isPhone = false;
    this.emailAddress = '';
    this.phoneNumber = '';
    this.isEmailError = '';
    this.isPhoneError = '';
    this.isDefault = true;
  }

  sendVerification() {

    if (this.emailAddress || this.phoneNumber) {
      const email_address = this.emailAddress ? this.emailAddress : '';
      const phone_number = this.phoneNumber ? this.phoneNumber : '';
      const vcode = this.verificationCode ? this.verificationCode : '';
      const applyCustomerObservable = this.idealsOneApiService.applyCustomerReq(email_address, phone_number, vcode);
      applyCustomerObservable.subscribe((customerData: any) => {
        this.customerData = customerData;
        if (this.customerData.data.error) {

          if (this.emailAddress == undefined || this.emailAddress == '') {
            this.isPhoneError = this.customerData.data.error;
          }
          else {
            this.isEmailError = this.customerData.data.error;
          }

        } else {
          this.isEmailError = 'success';
          this.isVerificationScreen = true;
        }
      });
    }
    else {
      return false;
    }
  }

  customerLogin(vcode: any) {

    if (vcode) {

      const email_address = this.emailAddress ? this.emailAddress : '';
      const phone_number = this.phoneNumber ? this.phoneNumber : '';
      const code = vcode.vcode ? vcode.vcode : '';

      const applyCustomerObservable = this.idealsOneApiService.applyCustomerReq(email_address, phone_number, code);
      applyCustomerObservable.subscribe((customerData: any) => {
        this.customerData = customerData;

        if (this.customerData.data.customer_information) {

          this.customerInformation = this.customerData.data.customer_information;
          this.customerProfile = this.customerInformation.image ? this.customerProfileUrl(this.customerInformation.image) : 'assets/img/user_profile.png';
          this.customerName = this.customerInformation.first_name || this.customerInformation.last_name ? `${this.customerInformation.first_name} ${this.customerInformation.last_name}` : 'Login';
          sessionStorage['customerInfo'] = JSON.stringify(this.customerInformation);
          console.log('customer information: ', this.customerInformation);
          this.isVerificationScreen = false;
          this.loginModalReference.close();
          this.isCodeError = '';
        }
        else {
          this.isCodeError = 'Invalid Verification Code';
        }

      });
    }
    else {
      return false;
    }
  }

  phoneVerification(event) {

    if (this.phoneNumber || this.emailAddress) {
      this.isDefault = false;
      const input = event.target.value ? event.target.value.toString() : 0;
      if (input.length == 10) {
        this.isEmail = true;
        this.isPhoneError = '';
      }
      else {
        this.isPhoneError = 'Please enter valid phone number';
        this.isEmail = true;
      }
    }
    else {
      this.isDefault = true;
      this.isPhoneError = '';
      this.isEmail = false;
    }
  }

  emailVerification(event: any) {

    if (this.emailAddress || this.phoneNumber) {

      this.isDefault = false;
      let inputval = event.target.value;
      var pattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;

      if (inputval.match(pattern)) {
        this.isEmailError = '';
        this.isPhone = true;
      } else {
        this.isEmailError = 'Please enter valid email';
        this.isPhone = true;
      }
    } else {
      this.isDefault = true;
      this.isEmailError = ''
      this.isPhone = false;
    }
  }

  preventCharacter(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode < 96 || charCode > 105) {
      return false;
    }
  }

  codeVerification(event: any) {
    if (event.target.value) {
      this.isEmailError = '';
    }
  }

  onFocus(event) {
    this.closeLogin();
  }
  // for customerProfile image senitize
  customerProfileUrl(ProfileUrl): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(ProfileUrl);
  }

}
